module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Light.271989b0a66b777434f988ae67d10f95.ttf";